module.exports = __webpack_public_path__ + "static/media/architecture.3b5245b8.jpg";